import React from 'react';

import {CssBaseline} from '@material-ui/core';
import {ThemeProvider} from '@material-ui/core/styles';

import { AppProvider } from './stores/AppStore';
import { UserProvider } from './stores/UserStore';
import { SecurityProvider } from './stores/SecurityStore';
import Router from './Router';
import smartengoTheme from './utils/theme';

const App = () => {
    return (
        <ThemeProvider theme={smartengoTheme}>
            <CssBaseline/>
            <AppProvider>
                <UserProvider>
                    <SecurityProvider>
                        <Router />
                    </SecurityProvider>
                </UserProvider>
            </AppProvider>
        </ThemeProvider>
    );
};

export default App;
